module.exports = __webpack_public_path__ + "media/images/help-inactive-279714c6.png";